import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39774f15"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 826.1 586.9"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", {
  id: "Ebene_2",
  "data-name": "Ebene 2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "cls-1",
    d: "M277,72.13c-249.2,86.59-358,356-85.42,378.5,237.45,19.56,298.71,133.9,425.82,117.1,168.86-22.33,166.72-259,167-259C789.07,12.25,545.07-21,277,72.13Z"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}